export default __webpack_public_path__ + "static/media/ph1-270x240.624fb8e9.jpg";